import { connect } from 'react-redux';
import { selectUserVenues } from 'selectors/general';
import VenueMultiSelector from './VenueMultiSelector';

const mapStateToProps = (state, ownProps) => {
  let { venues } = ownProps;

  if (!venues) {
    venues = selectUserVenues(state);
  }
  return {
    ...ownProps,
    venues: venues.map(({ venueSubtitle, ...rest }) => ({
      ...rest,
      venueSubtitle: venueSubtitle || undefined,
    })),
  };
};

export default connect(mapStateToProps)(VenueMultiSelector);
